import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { checkAuthentication } from "../api";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [authUser, setAuthUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  /* CHECK AUTH */

  const checkAuth = useCallback(async () => {
    try {
      const res = await checkAuthentication();
      setAuthUser(res.data.user);
      setIsAuthenticated(true);
      return true;
    } catch (error) {
      setAuthUser(null);
      setIsAuthenticated(false);
      return false;
    } finally {
      setIsLoading(false);
    }
  }, []);

  /* INITIAL SESSION */

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  /* CONTEXT */

  const values = { authUser, setAuthUser, isAuthenticated, setIsAuthenticated, isLoading, checkAuth };

  return <AuthContext.Provider value={values}>{children}</AuthContext.Provider>;
}

export const useUserContext = () => useContext(AuthContext);